<template>
  <div :style="hostWrapperStyle">
    <DynamicComponentProduction
      v-if="embeddedDcId"
      :dynamic-component-id="embeddedDcId"
      :is-production="renderingInProduction"
      :entity-id="entityId"
      :theme-mode="themeMode"
    />
  </div>
</template>

<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import ReferencedComponentId from "%/dynamic-component-editor/options/referenced-component-id";
import ContextBindings from "%/dynamic-component-editor/options/context-bindings";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import DynamicComponentProduction
  from "%/dynamic-component-editor/components/DynamicComponentProductionComponent.vue";
import DcHostMixin from "%/dynamic-component-editor/mixins/dc-host-picker-mixin";

export default {
  name: "CollectionItemsCommentsWidget",
  components: { DynamicComponentProduction },
  mixins: [StoryPageElementMixin, DcHostMixin],
  relatedComponents: ["Collection Items Comments Widget"],
  elementPanelSettings: {
    displayName: "Comments Widget",
    displayIcon: "document",
    elementGroup: "collectionItemsElements",
    elementType: "element",
  },
  options: [
    ReferencedComponentId,
    ContextBindings,
    LayoutWidth,
    new LayoutHeight({ default: "hug" }, true),
  ],
  data() {
    return {
      defaultComponentName: "Collection Items Comments Widget",
    };
  },
};
</script>
